import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img8.jpg';
import Domestic1 from './img12.jpg';
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="AgricultureMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Agriculture Commodities
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                  Agriculture Commodities
                </div>
                <div className='Each-Product-mid-details'>
                  At GaganaSAI International, we recognize the global demand for high-quality agricultural products and foodstuffs. Our dedicated team works directly with trusted farms and suppliers to source the finest commodities, ensuring consistent quality and reliability in every product.
                  <br /><br />
                  We are proud to be a leading supplier and distributor of premium food products from around the world. Leveraging our state-of-the-art logistics network, we ensure the timely delivery of top-quality products.
                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>OUR CORE OFFERINGS</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='product-section-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
    <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                WHY CHOOSE US ?
                </div>
                <div className='Each-Product-mid-details' style={{textAlign:'left'}}>
                  <b>Quality Assurance :</b> At GaganaSAI International, we uphold strict quality standards to ensure that all our products are free from contamination and comply with international food safety regulations, providing you with reliable and safe food solutions.
                    <br /><br />
                    <b>Sustainable Practices :</b> We work with suppliers who are committed to environmentally responsible practices, ensuring sustainable growth, ethical sourcing, and long-term supply stability for our customers.
                    <br /><br />
                    <b>Global Reach :</b> With a strong international presence, we efficiently export and import goods across various regions, enabling us to meet your needs wherever you are, ensuring timely and dependable delivery.
                    <br /><br />
                we are committed to providing the highest standards of quality and service to meet the needs of our global clientele.
                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic1} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Pulses & Beans",
      description: "At GaganaSAI International, we efficiently trade and deliver a wide variety of pulses, including chickpeas, lentils, beans, and more, to customers around the globe.",
      image: "/Products/Agriculture/1.png"
    },
    {
      title: "Processed Pulses",
      description: "As one of the leading suppliers of processed pulses, we cater to both wholesalers and retailers, providing high-quality products to meet diverse market demands.",
      image: "/Products/Agriculture/2.png"
    },
    {
      title: "Lentils",
      description: "We specialize in the wholesale distribution of lentils, offering a range of varieties to satisfy the unique requirements of our valued customers.",
        image: "/Products/Agriculture/3.png"
    },
    {
      title: "Nuts and Dry Fruits",
      description: "GaganaSAI International is a leading wholesale supplier of premium nuts, dried fruits, and spices, offering top-quality products to markets around the globe.",
      image: "/Products/Agriculture/4.png"
    },
    {
      title: "Fruits and Vegetables",
      description: "GaganaSAI International is one of the Middle East's top importers and exporters of fresh fruits and vegetables, ensuring the highest standards of freshness and quality.",
      image: "/Products/Agriculture/5.png"
    },
    {
      title: "Seed Spices",
      description: "We provide a diverse selection of high-quality seed spices, sourced from trusted suppliers worldwide and delivered directly to your destination.",
        image: "/Products/Agriculture/6.png"
    },
    {
      title: "Seed Spices",
      description: "We specialize in the import and export of high-quality rice, connecting global markets with premium varieties to meet diverse culinary needs.",
        image: "/Products/Agriculture/7.jpeg"
    },

    
  ];
  